export default __webpack_public_path__ + "static/media/bin.3273778b.svg";